/* eslint-disable no-console */
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { getDebuggerPassthroughEnabled, getVNDebuggerEnabled } from '../../VNTestMode/Selectors'
import { bridge_logPassthrough } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'

/**
 * VNDebugger hijacks the console.log function and displays all the console
 * logs that are being printed on the screen.
 * console.log('message', 'WARN') will highlight the message.
 * after 35 logs the logger will automatically begin removing the oldest logs.
 */
export const VNDebugger = () => {
  /* eslint-disable react-hooks/exhaustive-deps */
  let capturedLogs = []
  const debugPassthroughEnabled = useSelector(getDebuggerPassthroughEnabled)
  const displayDebugger = useSelector((state) => getVNDebuggerEnabled(state))

  const logContainer = useRef()
  const [{ dx, dy }, setOffset] = useState({
    dx: 0,
    dy: 0,
  })

  useEffect(() => {
    var origLog = console.log
    console.log = (...args) => {
      try {
        if (displayDebugger) {
          setTimeout(() => {
            if (capturedLogs.length >= 35) {
              capturedLogs.shift()
            }
            let arg = JSON.stringify(args[0], undefined, 2)
            console.warn(args)
            if (JSON.stringify(args[1])?.includes('WARN')) {
              arg = `<span>${arg}&nbsp;</span>`
              capturedLogs.push(arg)
              document.getElementById('vndebugger').innerHTML = `${capturedLogs.join('<br>')}`
              capturedLogs.push(arg)
            }
          }, 0)
        }

        if (debugPassthroughEnabled && window.location.pathname === '/customer-facing-display') {
          bridge_logPassthrough(args)
        }

        origLog(...args)
      } catch (error) {
        console.warn('error setting log')
      }
    }

    window.console = console
  }, [capturedLogs])

  const handleInput = (e, isMouse) => {
    const location = isMouse ? e : e.touches[0]

    const startPos = {
      x: location.clientX - dx,
      y: location.clientY - dy,
    }

    const handleMove = (e) => {
      if (e.target !== logContainer.current) return
      if (!logContainer.current) {
        return
      }
      const location = isMouse ? e : e.touches[0]
      const dx = location.clientX - startPos.x
      const dy = location.clientY - startPos.y

      logContainer.current.style.transform = `translate(${dx}px, ${dy}px)`
      setOffset({ dx, dy })
    }

    const handleEnd = () => {
      if (isMouse) {
        document.removeEventListener('mousemove', handleMove)
        document.removeEventListener('mouseup', handleEnd)
      } else {
        document.removeEventListener('touchmove', handleMove)
        document.removeEventListener('touchend', handleEnd)
      }
    }

    if (isMouse) {
      document.addEventListener('mousemove', handleMove)
      document.addEventListener('mouseup', handleEnd)
    } else {
      document.addEventListener('touchend', handleEnd)
      document.addEventListener('touchmove', handleMove)
    }
  }

  const clearLogs = () => {
    capturedLogs.splice(0, capturedLogs.length)
    document.getElementById('vndebugger').innerHTML = ``
  }

  if (!displayDebugger) {
    return null
  }

  return (
    <div
      ref={logContainer}
      onTouchStart={(e) => handleInput(e, false)}
      onMouseDown={(e) => handleInput(e, true)}
      style={{
        touchAction: 'none',
        zIndex: 10000000000,
        width: '35%',
        height: '25%',
        position: 'absolute',
        backgroundColor: 'gray',
      }}
    >
      <button onClick={clearLogs} style={{ right: 0, position: 'absolute', zIndex: 1, bottom: 0 }}>
        clear
      </button>
      <div
        id="vndebugger"
        style={{
          whiteSpace: 'pre-wrap',
          width: '100%',
          height: '85%',
          overflowY: 'scroll',
          position: 'absolute',
          backgroundColor: 'white',
        }}
      ></div>
    </div>
  )
}
